import axios from "axios";

import { clearObjFields } from "../../utils";

const BASE = "/api/v1/merchant-customer";

// Анхаар: устгах endpoint нь бусад дуудалтуудаас өөр API version дээр байна.
const DELETE_BASE = "/api/1.0/merchant-customer";

/** Харилцагчийн жагсаалт. `params` дотор page, pageSize болон filter-үүд орно. */
export const listClients = async (params = {}) => {
  const { data } = await axios.post(`${BASE}/list`, params);
  return data;
};

/**
 * Excel татахад хэрэглэнэ — хуудаслалтгүйгээр бүх ТААРСАН харилцагчийг авна.
 *
 * `filters` нь `useTableFilter`-ийн буцаадаг идэвхтэй шүүлтүүр. Үүнийг
 * дамжуулахгүй бол хэрэглэгч хүснэгтээ шүүсэн ч Export нь бүх харилцагчийг
 * татаж, шүүсэн үр дүн гэж эндүүрэхэд хүргэнэ.
 */
export const listAllClients = async (filters = {}) => {
  // `page`/`pageSize` нь `pagination: false`-тэй зөрчилддөг тул хасна
  const { page, pageSize, ...rest } = filters;

  const { data } = await axios.post(`${BASE}/list`, {
    pagination: false,
    ...clearObjFields(rest),
  });
  return data;
};

/** Нэг харилцагчийн дэлгэрэнгүй. Хариу нь `{ key, value }` талбаруудын массив. */
export const getClient = async (id) => {
  const { data } = await axios.get(`${BASE}/${id}`);
  return data;
};

export const updateClient = async (id, payload) => {
  const { data } = await axios.post(`${BASE}/${id}`, payload);
  return data;
};

export const deleteClient = async (id) => {
  const { data } = await axios.delete(`${DELETE_BASE}/${id}`);
  return data;
};

/** B2B харилцагчийн барааны үнийг файлаас оноох. */
export const uploadCustomerPrice = async (payload) => {
  const { data } = await axios.post("/api/v1/customerPrice", payload);
  return data;
};
